import React, { useEffect, useState } from 'react'
import { CustomBlockRenderer } from 'react-native-render-html'
import { ActivityIndicator, Dimensions, Platform, View } from 'react-native'
import { ResourceApi } from '@trivie/core/src/services/api-objects'
import { MediaPlayer } from '@trivie/ui-web/components/media-player/media-player'

const AudioRenderer: CustomBlockRenderer = function AudioRenderer(props) {
  const { tnode } = props
  const [src, setSrc] = useState<any>('')

  useEffect(() => {
    if (!src) {
      // console.log('native: fetching video source')
      ResourceApi.getSourceDetails(Number(tnode.attributes.source_id)).then((res: any) => {
        setSrc(res.data.filename_or_url)
      })
    }
  }, [tnode])

  return src ? (
    <MediaPlayer url={src} variant="audio" />
  ) : (
    <View
      style={{
        flex: 0,
        height: '100%',
        width: Dimensions.get('screen').width - 40,
        maxHeight: 80,
      }}
    >
      <ActivityIndicator />
    </View>
  )
}

export default AudioRenderer
